import * as React from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './tooltip'
import { CircleHelp } from 'lucide-react'

const labelVariants = cva(
  'text-sm font-bold leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
)

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
  VariantProps<typeof labelVariants> & {
    required?: boolean
    tooltip?: string
  }
>(({ className, required = false, tooltip, ...props }, ref) => (
  <div>
    <LabelPrimitive.Root
      ref={ref}
      className={cn('cursor-pointer', labelVariants(), className, { 'required-label': required })}
      {...props}
    />
    {tooltip ? (
      <TooltipProvider delayDuration={300}>
        <Tooltip>
          <TooltipTrigger type="button">
            <CircleHelp size={12} className="ml-1" />
          </TooltipTrigger>
          <TooltipContent>
            <p>{tooltip}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    ) : null}
  </div>
))
Label.displayName = LabelPrimitive.Root.displayName

export { Label }
